<article class="purchase-order-summary">
  <dl class="purchase-order-summary__seller-info">
    <div>
      <dt>Vendedor</dt>
      <dd>{{ order.branch.companyName }}</dd>
    </div>
    <div>
      <dt>Filial</dt>
      <dd>{{ order.branch.externalReference }}</dd>
    </div>
    <div>
      <dt>Und. de Negócio</dt>
      <dd>{{ order.branch.businessUnit | businessUnit }}</dd>
    </div>
    <div>
      <dt>Endereço de coleta</dt>
      <dd>{{ order.branch.address | address }}</dd>
    </div>
    <div>
      <dt>Contato</dt>
      <dd>{{ order.branch.contact.contact }}</dd>
    </div>
    <div>
      <dt>Motivo Recusa</dt>
      <dd>{{ order.reason | logReason }}</dd>
    </div>
  </dl>
  <hr />
  <section class="purchase-order-summary__fiscal-info">
    <h2 class="purchase-order-summary__fiscal-info__title">Detalhe do Tratamento Fiscal</h2>
    <dl class="purchase-order-summary__fiscal-info__list">
      <div>
        <dt>NFe</dt>
        <dd>
          @if (order.invoice?.code && order.invoice?.id) {
          <span pdsChip (click)="onClickPreviewInvoice(order)" icon="download">
            <span>{{ order.invoice?.code }}</span> </span
          >} @else if (order.invoice?.code ) {
          <span pdsChip>
            <span>{{ order.invoice?.code }}</span>
          </span>
          } @else {
          <span pdsChip>-</span>
          }
        </dd>
      </div>
      <div>
        <dt>Etiqueta</dt>
        <dd>
          <span pdsChip>{{ invoiceStatus | invoiceStatus }}</span>
        </dd>
      </div>
      <div>
        <dt>Justificativa</dt>
        <dd>{{ order.fiscalArchivedJustification | reasonRemoverOrder }}</dd>
      </div>
    </dl>
  </section>
</article>
<peca-document-preview #documentPreview [disableDeleteAction]="true" />
